import { object, string, union, unknown, z } from "zod";

export const FavouritesResponseDTOError = object({
  requestDTO: object({
    dataMap: object({
      error: string(),
    }),
  }),
});

export const FavouritesResponseDTOSuccess = unknown();

export type FavouritesResponseDTOSuccess = z.infer<
  typeof FavouritesResponseDTOSuccess
>;

export type FavouritesResponseDTOError = z.infer<
  typeof FavouritesResponseDTOError
>;

export const FavouritesResponseDTO = union([
  FavouritesResponseDTOError,
  FavouritesResponseDTOSuccess,
]);

export type FavouritesResponseDTO = z.infer<typeof FavouritesResponseDTO>;
